import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled('div')`
  position: fixed;
  top: 68px;
  left: 0px;
  width: 100%;
  z-index: 1000;
`;

const WarningBox = styled('div')`
  background: rgba(219, 55, 55, 0.2);
  border: 1px solid rgba(219, 55, 55, 0.2);
  border-radius: 4px;

  width: 409px;
  height: 44px;

  color: #373e44;
  font-size: 13px;
  margin: 0px auto;
  line-height: 42px;
  text-align: center;
`;

export default class ValidationMessageTip extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { show, customMessage } = this.props;
    if (show === false) {
      return null;
    }

    return (
      <Wrapper>
        <WarningBox>
          {customMessage && customMessage.trim() !== ''
            ? customMessage
            : 'There are incomplete required fields. Please complete them.'}
        </WarningBox>
      </Wrapper>
    );
  }
}

ValidationMessageTip.defaultProps = {
  show: false,
  customMessage: false
};

ValidationMessageTip.propTypes = {
  show: PropTypes.bool,
  customMessage: PropTypes.string
};
